// extracted by mini-css-extract-plugin
export default {"zombiePage":"zombie_zombiePage__gTEq+","zombie":"zombie_zombie__Mj-Hk"};